<main class="d-flex flex-column">
  <div class="warning">
    <b>Atenção:</b> O servidor indicado poderá ser acionado a responder, durante o evento, a questões de competencia da organização representada.
  </div>
  <div class="d-flex flex-column">
    <p>Integrará a Equipe de Governo neste evento, representando a(o) {{newAuthForm.organization?.name}} o(a) servidor(a): </p>
  </div>
  <div class="d-flex flex-column">
    <div class="d-flex flex-row">
      <p-radioButton (ngModelChange)="himselfSelected()" [disabled]="undoCredential" value="himself" [(ngModel)]="newAuthForm.representing" inputId="reprHimself"/>
      <label for="reprHimself">{{newAuthForm.name}}</label>
    </div>
    <div class="d-flex flex-row">
      <p-radioButton (ngModelChange)="otherSelected()" [disabled]="undoCredential" value="other" [(ngModel)]="newAuthForm.representing" inputId="reprOther"/>
      <label for="reprOther">Outra pessoa:</label>
    </div>
    <div class="reprInfo">

      <div class="col">
        <label for="reprName" class="text-end" [ngClass]="newAuthForm.representing === 'other' ? '' : 'disabled'">Nome*</label>
      </div>
      <div class="row align-items-center my-2" [ngClass]="'d-flex'" >
        <div class="col px-1">
          <p-autoComplete [disabled]="newAuthForm.representing !== 'other' || undoCredential"
                          id="reprName" class="w-100" (onSelect)="loadAcInfo()" [(ngModel)]="agente"
                          [suggestions]="filteredAgentes" (completeMethod)="filterAgentes($event)"
                          optionLabel="name" ></p-autoComplete>

          
        </div>
      </div>
    </div>

  </div>
  <div class="flex-column" [hidden]="!isOtherAndLooked">
    <label for="reprRole">Cargo do Representante*</label>

    <input type="text" pInputText [(ngModel)]="newAuthForm.authorityRole"
      class="w-100" id="reprRole" [disabled]="undoCredential" />
  </div>
  <div class="flex-column" [ngClass]="isOtherAndLooked ? 'd-flex' : ''"  [hidden]="!isOtherAndLooked">
    <label for="municipio">Município do Representante*</label>
    <p-dropdown class="locality-dropbox" [options]="localities" required
        [(ngModel)]="newAuthForm.authorityLocalityId" field="label" [disabled]="undoCredential"
        optionLabel="name" optionValue="id" placeholder="Selecione o seu Município">
      </p-dropdown>
  </div>
  <div class="flex-column" [ngClass]="isOtherAndLooked ? 'd-flex' : ''"  [hidden]="!isOtherAndLooked">
    <label for="email">Email do Representante*</label>
    <input type="text" pInputText [(ngModel)]="newAuthForm.authorityEmail" [disabled]="undoCredential"
      class="w-100" id="email" [readOnly]="fromAc.authorityEmail" />
  </div>

</main>
<footer class="px-2 d-flex flex-column">
  <div class="d-flex gap-2">
    <button [disabled]="!isAuthValid" (click)="finishRegister()" class="align-self-start">Confirmar</button>
    <p-inputSwitch [(ngModel)]="undoCredential" ></p-inputSwitch>
    Descredenciar
  </div>
  <p>Na sequencia, você poderá corrigir esta ou confirmar novas indicações.</p>
</footer>
